import React from "react";


export const FINANCIAL_INFO_TITLE = "Financial Information";

export const REQUIRED_FIELD_TITLE = "*Required field";
